import { Type } from "class-transformer";
import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class ProjectStatistics {
    //netgen start
    structurePaths: string[];
    maxStructurePathDepth = 0;
    @Type(() => Date)
    endDate: Date;
    milestoneDates: OrdinaryObject<Date>;
    numEvents = 0;
    numFinishedEvents = 0;
    donePercentage = 0;
    plannedTime = 0;
    doneTime = 0;
    plannedTimeFinished = 0;
    doneTimeFinished = 0;
    timePercentage = 0;
    //netgen end
}
